<template>
  <div>
    <autocomplete-input
      :query="participantQuery"
      :items="$store.state.participants"
      :placeholder="$store.state.localizedStrings.nameOrBib"
      :display-fn="displayParticipant"
      :input-class="inputClass"
      :loading="$store.state.participantSearchLoading"
      @update:query="onQueryUpdate"
      @input-changed="onInputChanged"
      @item-selected="onItemSelected"
    />
    <div
      v-if="showValidation"
      class="js-participant-validation-msg"
    >
      <span class="find-your-photos-bar__fail">!</span>
      <div class="find-your-photos-bar__fail-message">{{ $store.state.localizedStrings.selectParticipant }}</div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import AutocompleteInput from './AutocompleteInput.vue'

export default {
  name: 'ParticipantTypeahead',
  components: {
    AutocompleteInput: AutocompleteInput
  },
  computed: {
    participantQuery: function () {
      return this.$store.state.participantQuery
    },
    selectedOccasion: function () {
      return this.$store.state.selectedOccasion
    },
    showValidation: function () {
      return this.$store.state.validationAttempted && !this.$store.getters.participantValid
    },
    inputClass: function () {
      var classes = ['find-your-photos-bar__input', 'typeahead', 'typeahead-participants']
      if (this.$store.state.validationAttempted) {
        if (this.$store.getters.participantValid) {
          classes.push('find-your-photos-bar__input--success')
        } else {
          classes.push('find-your-photos-bar__input--fail')
        }
      }
      return classes
    }
  },
  watch: {
    selectedOccasion: function () {
      // Reset participants when occasion changes
      this.$store.commit('setParticipants', [])
    }
  },
  created: function () {
    this.debouncedSearch = debounce(this.doSearch, 300)
  },
  methods: {
    displayParticipant: function (participant) {
      return participant.ln + ', ' + participant.fn + ' (' + participant.bn + ')'
    },
    onQueryUpdate: function (value) {
      this.$store.commit('setParticipantQuery', value)
    },
    onInputChanged: function (value) {
      // Clear selected participant when user types
      this.$store.commit('setSelectedParticipant', null)
      if (value.length >= 3 && this.selectedOccasion) {
        this.debouncedSearch(value)
      } else {
        this.$store.commit('setParticipants', [])
      }
    },
    doSearch: function (searchString) {
      if (this.selectedOccasion) {
        this.$store.dispatch('searchParticipants', {
          occasionRef: this.selectedOccasion.occasionRef,
          searchString: searchString
        })
      }
    },
    onItemSelected: function (participant) {
      this.$store.commit('setParticipantQuery', this.displayParticipant(participant))
      this.$store.commit('setSelectedParticipant', participant)
    }
  }
}
</script>



// WEBPACK FOOTER //
// WebResources/vue/find-my-photos/components/ParticipantTypeahead.vue